import classNames from 'classnames';
import Link from 'next/link';
import { FC } from 'react';
import styles from './index.module.scss';

interface SelectItemProps {
  icon: React.ReactNode;
  text: string;
  href?: string;
  onClick?: () => void;
  isExit?: boolean;
}

const SelectItem: FC<SelectItemProps> = ({ icon, text, href, onClick, isExit }) => {
  const content = (
    <div className={classNames(styles.item, { [styles.exit]: isExit })}>
      <div className={styles.icon}>{icon}</div>
      <span>{text}</span>
    </div>
  );

  if (href) {
    return (
      <Link href={href} className={styles.link}>
        {content}
      </Link>
    );
  }

  return (
    <button className={styles.button} onClick={onClick}>
      {content}
    </button>
  );
};

export default SelectItem;
